export default __webpack_public_path__ + "static/media/Group8401.8e44210c.svg";